export default __webpack_public_path__ + "static/media/qa.8f91b751.svg";